import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { DialogDisplayProps } from "./interface";

const DialogDisplay = ({
    dialogOpenState,
    dialogTitle,
    updateDialogMessage,
    confirm,
    dialogMessage,
    setDialogOpenState,
}: DialogDisplayProps) => {
    return (
        <Dialog
            open={dialogOpenState}
            onClose={() => {
                setDialogOpenState(false);
            }}
        >
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>{dialogMessage}</DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        updateDialogMessage("Processing...");
                        confirm();
                    }}
                >
                    Confirm
                </Button>
                <Button
                    onClick={() => {
                        setDialogOpenState(false);
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogDisplay;
